import {
  BuscadorTurnoBody,
  BuscadorTurnoContainer,
  BuscadorTurnoCurva,
  BuscadorTurnoFooter,
  BuscadorTurnoHeader,
  BuscadorTurnoTecladoContainer,
} from "./localStyle";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { quitarTildes } from "global/utils/quitarTildes";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { createDtoBusquedaTurnosDisponibles } from "./dtoBusquedaTurnosDisponibles";
import { hideModal, showModal } from "global/context/action/modal/modal";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import TecladoAlfanumerico from "_+_Portal/components/Genericos/TecladoAlfanumerico/TecladoAlfanumerico";
import BarraBlanca from "_+_Portal/_-_Autocheckin/components/genericos/BarraBlanca/BarraBlanca";
import InputBuscador from "_+_Portal/_-_Autocheckin/components/genericos/InputBuscador/InputBuscador";
import {
  wsGetVerificaConsultaMedica,
  wsPostConsultaMedTurnos,
} from "_+_Portal/context/Actions/turnos/consultaMedTurnos";
import { PortalContext } from "_+_Portal/context/Provider";
import {
  wsGetVerificaEstudiosQr,
  wsPostTurnosEstudiosQr,
} from "_+_Portal/context/Actions/turnos/estudioTurnos";
import Carousel from "_+_Portal/_-_Autocheckin/components/genericos/Carousel/Carousel";
import { setNuevoTurno } from "_+_Portal/context/Actions/nuevoTurno/nuevoTurno";
import ModalVerificaOs from "_+_Portal/_-_Autocheckin/components/genericos/ModalVerificaOs/ModalVerificaOs";
import { editaTurnosDisponibles } from "_+_Portal/context/Actions/turnos/turnosDisponibles";
import { estudioGrupo } from "_+_Portal/context/Actions/estudioGrupo/estudioGrupo";
import Modal from "global/component/Genericos/Modal/Modal";

const BuscadorTurno = () => {
  //#region --------- context ---------------
  const { authState, toasterDispatch, modalState, modalDispatch } =
    useContext(GlobalContext);
  const {
    consultaMedTurnosDispatch,
    estudioTurnosDispatch,
    nuevoTurnoState,
    nuevoTurnoDispatch,
    estudioGrupoState,
    estudioGrupoDispatch,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
  } = useContext(PortalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const [busquedaStr, setBusquedaStr] = useState(
    quitarTildes(
      nuevoTurnoState.nuevoTurno.seleccionMasSolicitado?.descripcion,
    ),
  );
  const [filteredData, setFilteredData] = useState();
  const [prestacionesInicial, setPrestacionesInicial] = useState();
  const [loading, setLoading] = useState(true);
  const maxLength = 25;
  const history = useHistory();
  const dtoVerificaOs = {
    especialidad: null,
    fechaDesde: null,
    medico: null,
    particular: false,
    idPacFamiliar: -1,
    osAlternativa: false,
    grupoMedico: false,
    flgVideoAtencion: nuevoTurnoState.nuevoTurno.videoAtencion,
    concontraste: null,
  };
  let isAgenda = null;
  const idCircuitoMensajesList = [1, 3, 5, 6, 7, 8];
  const idCircuitoParticular = [9];
  const idCircuitoOsAlternativa = [91];
  const idCircuitoSinTurnoPrevio = [10];

  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------

  const obtenerFechaActual = () => {
    const hoy = new Date();
    const año = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, "0");
    const dia = String(hoy.getDate()).padStart(2, "0");
    return `${año}-${mes}-${dia}`;
  };

  const onEnterBuscar = () => {};

  const onChangeTeclado = (value) => {
    if (value) {
      filtrarData(value);
    } else {
      setBusquedaStr("");
    }
  };

  const onDeleteTeclado = () => {
    setNuevoTurno({ seleccionMasSolicitado: null })(nuevoTurnoDispatch);
    setBusquedaStr("");
    filtrarData("");
    sortedDataDefault();
  };

  const filtrarData = (value) => {
    setBusquedaStr(value);
    const filtered = filteredData?.filter((item) => {
      const searchWords = value
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .split(" ");
      return searchWords.every((word) =>
        item["descripcion"]
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(word),
      );
    });
    setFilteredData(filtered);
  };

  const onClickBuscarPrestacion = (prestacion) => {
    setLoading(true);
    // Reset de data antes de buscar nuevamente
    dtoVerificaOs.particular = false;
    dtoVerificaOs.osAlternativa = false;
    setNuevoTurno({ dtoBusqueda: null })(nuevoTurnoDispatch);
    const { codigo, id } = nuevoTurnoState.nuevoTurno.familiar;
    dtoVerificaOs.idPacFamiliar = codigo === 0 ? -1 : id;
    dtoVerificaOs.idPacFamiliar = codigo === 0 ? -1 : id;
    dtoVerificaOs.medico = prestacion.medico;
    dtoVerificaOs.especialidad = prestacion.especialidad;
    dtoVerificaOs.fechaDesde = obtenerFechaActual();
    dtoVerificaOs.concontraste = prestacion.conContraste;
    dtoVerificaOs.grupoMedico = {
      Id: prestacion.id,
      Descripcion: prestacion.descripcion,
      Particular: dtoVerificaOs.particular,
    };
    isAgenda = prestacion.id < 0;
    if (isAgenda) {
      wsGetVerificaConsultaMedica(
        dtoVerificaOs.especialidad,
        dtoVerificaOs.medico,
        -1,
        false,
        nextStepVerificaOs,
      )(consultaMedTurnosDispatch);
    } else {
      wsGetVerificaEstudiosQr(
        prestacion.id,
        dtoVerificaOs.particular,
        false,
        false,
        false,
        nextStepVerificaOsEstudio,
      )(estudioTurnosDispatch);
    }
  };

  const nextStepVerificaOs = (isCorrect, data) => {
    if (isCorrect) {
      if (
        idCircuitoMensajesList.includes(data?.codigo) &&
        !data?.detail?.continua
      ) {
        setLoading(false);
        showToaster(
          {
            texto: data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      } else if (
        idCircuitoParticular.includes(data?.codigo) &&
        !data?.detail?.continua
      ) {
        setLoading(false);
        showModal(
          <ModalVerificaOs
            data={data}
            btnAceptarStr={"Tomar como particular"}
            onClickCancelar={dismiss}
            onClick={onClickTomarComoParticular}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else if (
        idCircuitoOsAlternativa.includes(data?.codigo) &&
        !data?.detail?.continua
      ) {
        setLoading(false);
        showModal(
          <ModalVerificaOs
            data={data}
            btnAceptarStr={"Tomar con OS alternativa"}
            onClick={onClickTomarConOsAlternativa}
            onClickCancelar={dismiss}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else if (idCircuitoSinTurnoPrevio.includes(data?.codigo)) {
        setLoading(false);
        showModal(
          <ModalVerificaOs
            data={data}
            btnAceptarStr={"Ir a menú principal"}
            onClick={onClickSinTurnoPrevio}
            onClickCancelar={dismiss}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else {
        buscarTurnosDisponibles();
      }
    } else {
      setLoading(false);
      showToaster(
        {
          texto: data?.mensaje ? data?.mensaje : "Ha ocurrido un error",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  const nextStepVerificaOsEstudio = (isCorrect, data) => {
    if (isCorrect) {
      buscarTurnosDisponibles();
    } else {
      if (
        idCircuitoMensajesList.includes(data?.detail?.codigo) &&
        !data?.detail?.continua
      ) {
        setLoading(false);
        showToaster(
          {
            texto: data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      } else if (
        idCircuitoParticular.includes(data?.detail?.codigo) &&
        !data?.detail?.continua
      ) {
        setLoading(false);
        showModal(
          <ModalVerificaOs
            data={data}
            btnAceptarStr={"Tomar como particular"}
            onClickCancelar={dismiss}
            onClick={onClickTomarComoParticular}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else if (
        idCircuitoOsAlternativa.includes(data?.detail?.codigo) &&
        !data?.detail?.continua
      ) {
        setLoading(false);
        showModal(
          <ModalVerificaOs
            data={data}
            btnAceptarStr={"Tomar con OS alternativa"}
            onClick={onClickTomarConOsAlternativa}
            onClickCancelar={dismiss}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else if (idCircuitoSinTurnoPrevio.includes(data?.detail?.codigo)) {
        setLoading(false);
        showModal(
          <ModalVerificaOs
            data={data}
            btnAceptarStr={"Ir a menú principal"}
            onClick={onClickSinTurnoPrevio}
            onClickCancelar={dismiss}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else {
        setLoading(false);
        showToaster(
          {
            texto: data?.mensaje ? data?.mensaje : "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }
    }
  };

  const buscarTurnosDisponibles = () => {
    if (isAgenda) {
      setNuevoTurno({ dtoBusqueda: dtoVerificaOs })(nuevoTurnoDispatch);
      wsPostConsultaMedTurnos(
        dtoVerificaOs.especialidad,
        dtoVerificaOs.medico,
        obtenerFechaActual(),
        dtoVerificaOs.particular,
        false,
        -1,
        false,
        (isCorrect, data) =>
          nextStepTurnosDisponibles(isCorrect, data, dtoVerificaOs, true),
      )(consultaMedTurnosDispatch);
    } else {
      let dtoPost = createDtoBusquedaTurnosDisponibles({
        familiar: nuevoTurnoState.nuevoTurno.familiar.paciente,
        fechaDesde: obtenerFechaActual(),
        gruposMedico: dtoVerificaOs.grupoMedico,
        particular: dtoVerificaOs.particular,
        videoAtencion: dtoVerificaOs.flgVideoAtencion,
        conContraste: dtoVerificaOs.concontraste,
        OsAlternativa: dtoVerificaOs.osAlternativa,
      });
      setNuevoTurno({ dtoBusqueda: dtoPost })(nuevoTurnoDispatch);
      wsPostTurnosEstudiosQr(dtoPost, -1, (isCorrect, data) =>
        nextStepTurnosDisponibles(isCorrect, data, dtoPost, false),
      )(estudioTurnosDispatch);
    }
  };

  const nextStepTurnosDisponibles = (isCorrect, data, dtoPost, isConsulta) => {
    if (isCorrect) {
      if (isConsulta) {
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: data.data,
          grupoMedico: null,
          particular: dtoVerificaOs.particular,
          idEstudio: null,
          descEstudio: null,
          descEspecialidad: dtoVerificaOs?.grupoMedico?.Descripcion
            ? dtoVerificaOs?.grupoMedico?.Descripcion
            : dtoVerificaOs,
          fechaBusqueda: data.fechaBusqueda,
          dtoBusqueda: dtoVerificaOs,
          volverOrigen: "CONSULTA_MEDICA",
          proceso: "consMedica",
        })(turnosDisponiblesDispatch);
      } else {
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: data.turnos,
          GruposMedico: dtoPost.GruposMedico,
          particular: dtoPost.particular,
          idEstudio: Array.isArray(dtoPost.GruposMedico)
            ? dtoPost.GruposMedico[0].Id
            : dtoPost.idGrupoMedico,
          descEstudio: Array.isArray(dtoPost.GruposMedico)
            ? dtoPost.GruposMedico[0].Descripcion
            : dtoPost.Descripcion,
          descEspecialidad: null,
          fechaBusqueda: data.fechaBusqueda,
          // sectorTurno,
          dtoBusqueda: dtoPost,
          volverOrigen: "ESTUDIOS",
          proceso: "estudios",
          // circuito: leyendaCircuito,
        })(turnosDisponiblesDispatch);
      }
      setLoading(false);
      history.push(`/turnosDisponibles`);
    }
  };

  const sortedDataDefault = () => {
    const arrGrupoMed = (estudioGrupoState.estudioGrupo?.data ?? []).filter(
      (item) => {
        return (
          item.sonPracticas === false &&
          item.idCircuito !== "RMN" &&
          item.idCircuito !== "TOMO"
        );
      },
    );
    const sortedData = arrGrupoMed.sort((a, b) => {
      if (a.cantBusquedas > b.cantBusquedas) return -1;
      if (a.cantBusquedas < b.cantBusquedas) return 1;
      return 0;
    });
    setPrestacionesInicial(sortedData);
    setFilteredData(sortedData);
    setLoading(false);
  };

  const dismiss = () => {
    hideModal()(modalDispatch);
  };

  const onClickTomarComoParticular = () => {
    dtoVerificaOs.particular = true;
    dtoVerificaOs.grupoMedico = {
      ...dtoVerificaOs.grupoMedico,
      Particular: true,
    };
    dismiss();
    setLoading(true);
    buscarTurnosDisponibles();
  };

  const onClickTomarConOsAlternativa = () => {
    dtoVerificaOs.osAlternativa = true;
    dismiss();
    setLoading(true);
    if (isAgenda) {
      wsGetVerificaConsultaMedica(
        dtoVerificaOs,
        nextStepVerificaOs,
      )(consultaMedTurnosDispatch);
    } else {
      wsGetVerificaEstudiosQr(
        dtoVerificaOs,
        nextStepVerificaOs,
      )(estudioTurnosDispatch);
    }
  };
  const onClickSinTurnoPrevio = () => {
    history.push("/home");
  };
  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------

  useEffect(() => {
    setNuevoTurno({ familiar: authState.auth.data })(nuevoTurnoDispatch);
    estudioGrupo()(estudioGrupoDispatch);
  }, []);

  useEffect(() => {
    if (estudioGrupoState.estudioGrupo.data !== null) {
      sortedDataDefault();
    }
  }, [estudioGrupoState.estudioGrupo.data]);

  useEffect(() => {
    if (prestacionesInicial) {
      if (nuevoTurnoState.nuevoTurno.seleccionMasSolicitado?.descripcion) {
        filtrarData(
          quitarTildes(
            nuevoTurnoState.nuevoTurno.seleccionMasSolicitado?.descripcion,
          ),
        );
      }
    }
  }, [prestacionesInicial]);
  //#endregion  -------- useEffect ---------------

  return (
    <>
      {modalState.modal.show && <Modal />}
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <BuscadorTurnoContainer>
        <BarraBlanca
          title={"Busca el turno que necesitas"}
          etiquetaBusqueda={false}
        />
        <BuscadorTurnoHeader>
          <div className="BuscadorTurno-input-container">
            <InputBuscador value={busquedaStr} />
          </div>
        </BuscadorTurnoHeader>
        <BuscadorTurnoBody>
          {filteredData && !loading && (
            <Carousel
              opcDelete={false}
              items={filteredData}
              title={"Resultados de búsqueda"}
              name={"descripcion"}
              onClick={(item) => onClickBuscarPrestacion(item)}
            />
          )}
        </BuscadorTurnoBody>
        <BuscadorTurnoFooter>
          <BuscadorTurnoCurva></BuscadorTurnoCurva>
          <BuscadorTurnoTecladoContainer>
            <TecladoAlfanumerico
              sinNumeros={true}
              modeLight={true}
              onEnter={onEnterBuscar}
              enterStr={"Enter"}
              onChange={onChangeTeclado}
              maxLength={maxLength}
              onDelete={onDeleteTeclado}
            />
          </BuscadorTurnoTecladoContainer>
        </BuscadorTurnoFooter>
      </BuscadorTurnoContainer>
    </>
  );
};

export default BuscadorTurno;
